export const apiBaseURL = process.env.REACT_APP_API_URL || '';
export const DASHBOARD_URL = '/';
export const LANDING_URL = process.env.REACT_APP_LANDING_URL || '/';
